import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetchLineages, deleteLineage} from './data-lineage.actions';
import DataLineageTable from './components/data-lineage-table';
import Modal from '../../components/modal';
import {Row, Col} from 'react-bootstrap';
import Button from '../../components/button';

class DataLineage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      deleteLineageId: null,
      menuAnchorEl: null,
      menuRowId: null,
    };
  }

  componentDidMount() {
    this.props.fetchLineages();
  }

  handleCreate = () => {
    if (this.props.history) {
      this.props.history.push('/lineage-library/new');
    } else {
      window.location.href = '/lineage-library/new';
    }
  };

  handleMenuOpen = (event, rowId) => {
    this.setState({menuAnchorEl: event.currentTarget, menuRowId: rowId});
  };

  handleMenuClose = () => {
    this.setState({menuAnchorEl: null, menuRowId: null});
  };

  handleDeleteClick = (rowId) => {
    this.setState({showDeleteModal: true, deleteLineageId: rowId, menuAnchorEl: null, menuRowId: null});
  };

  handleDeleteCancel = () => {
    this.setState({showDeleteModal: false, deleteLineageId: null});
  };

  handleDeleteConfirm = () => {
    const {deleteLineageId} = this.state;
    this.props.deleteLineage(deleteLineageId);
    this.setState({showDeleteModal: false, deleteLineageId: null});
  };

  render() {
    const {loading, lineages} = this.props;
    const rows = Array.isArray(lineages) ? lineages : (lineages && lineages.response) || [];
    const {showDeleteModal, menuAnchorEl, menuRowId} = this.state;
    return (
      <div className="app-content-container">
        <div className="page-content select-container in">
          <h2>Lineage Library</h2>
          <Row>
            <Col sm={12} xs={12}>
              <div className="align-right action-bar padding-20">
                <Button
                  label="Create new lineage"
                  className="btn btn-action"
                  data-testid="lineage-new-btn"
                  onClick={this.handleCreate}
                />
              </div>
              <DataLineageTable
                lineages={rows}
                loading={loading}
                onMenuOpen={this.handleMenuOpen}
                menuAnchorEl={menuAnchorEl}
                menuRowId={menuRowId}
                onDeleteClick={this.handleDeleteClick}
                onMenuClose={this.handleMenuClose}
              />
            </Col>
          </Row>
          <Modal
            open={showDeleteModal}
            close={this.handleDeleteCancel}
            confirm={this.handleDeleteConfirm}
            title="Delete Data Lineage"
            content={
              (() => {
                const lineage = rows.find((l) => l.id === this.state.deleteLineageId || l.diagram_id === this.state.deleteLineageId);
                const name = lineage && (lineage.name || lineage.diagram_name) ? (lineage.name || lineage.diagram_name) : '';
                return <span>Are you sure you want to delete <b>{name}</b>?</span>;
              })()
            }
            primaryButton="Yes"
            secondaryButton="No"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lineages: state.dataLineage.lineages,
  loading: state.dataLineage.loading,
});

export default connect(mapStateToProps, {fetchLineages, deleteLineage})(DataLineage);
